module.exports = __webpack_public_path__ + "static/media/tetrapackExplore.0b696767.png";